import { Component, inject, input, model, OnChanges, output, SimpleChanges } from '@angular/core';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { AdvanceInvoiceStateEnums } from 'src/app/enum/advance-invoice-state-enum';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { AdvanceInvoiceConceptModel } from 'src/app/models/invoicing/advance-invoice-concept.model';
import { AdvanceInvoiceModel } from 'src/app/models/invoicing/advance-invoice.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { AdvanceInvoiceConceptRegisterModel } from 'src/app/models/tables/invoicing/advance-invoice-concept-register.model';
import { AdvanceInvoiceConceptService } from 'src/app/services/invoicing/advance-invoice-concept.service';

@Component({
  selector: 'app-advance-invoice-concept',
  templateUrl: './advance-invoice-concept.component.html',
  styleUrls: ['./advance-invoice-concept.component.scss'],
  standalone: false
})
export class AdvanceInvoiceConceptComponent implements OnChanges {

  private readonly advanceInvoiceConceptService = inject(AdvanceInvoiceConceptService);

  advanceInvoiceModel = input<AdvanceInvoiceModel>(new AdvanceInvoiceModel());
  disabled = input<boolean>(false);
  isFormView = model<boolean>(true);
  updateAdvanceInvoice = output<AdvanceInvoiceModel>();

  advanceInvoiceConcept: AdvanceInvoiceConceptModel = new AdvanceInvoiceConceptModel();
  ascendant: boolean = true;
  columnSort: string | null = null;
  detailData: PagedResponseModel<AdvanceInvoiceConceptRegisterModel> = new PagedResponseModel<AdvanceInvoiceConceptRegisterModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  limit: number = 10;
  output$ = new Subject<any>();
  page: number = 1;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];

  async ngOnInit(): Promise<void> {
    await this.getColumnsForConceptsAdvanceInvoice();
    this.tableActions = this.getDefaultActions();
  }

  ngOnChanges(changes: SimpleChanges) {
    const advanceInvoiceModel = changes["advanceInvoiceModel"];

    if (advanceInvoiceModel && advanceInvoiceModel.currentValue.advanceInvoiceId != 0) {
      this.getConceptsAdvanceInvoiceWithPagination();
      this.advanceInvoiceConcept = new AdvanceInvoiceConceptModel();
      this.disabledButton = this.advanceInvoiceModel().advanceInvoiceState != AdvanceInvoiceStateEnums.open;
      this.tableActions = this.getDefaultActions();
    }
  }

  async getColumnsForConceptsAdvanceInvoice() {
    try {
      this.detailHeader = await firstValueFrom(this.advanceInvoiceConceptService.getColumnsForConceptsAdvanceInvoice());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getConceptsAdvanceInvoiceWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.advanceInvoiceConceptService.getAdvanceInvoiceConceptsByAdvanceInvoiceIdWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.advanceInvoiceModel().invoiceId
      ));
    } catch (error) {
      console.error('Error al buscar los conceptos de las facturas anticipadas.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    if (!this.advanceInvoiceModel().swInvoiceDifference &&
      this.advanceInvoiceModel().advanceInvoiceState == AdvanceInvoiceStateEnums.open) {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    } else {
      return [];
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView.set(isFormView);
  }

  getUpdateListConcept() {
    this.getConceptsAdvanceInvoiceWithPagination();
  }

  async onAction(event: { action: string, item?: AdvanceInvoiceConceptRegisterModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      const response = await firstValueFrom(this.advanceInvoiceConceptService.getAdvanceInvoiceConceptById(event.item.advanceInvoiceConceptId));
      if (response) {
        this.isFormView.set(true);
        this.advanceInvoiceConcept = response;
      }
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getConceptsAdvanceInvoiceWithPagination();
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

}
